import * as serviceContext from './serviceContext';
import { REPORTS_ROOT as ReportsURL } from '../configs/api';

var options = {};
var headers = new Headers();

headers.append('Content-Type', 'application/json');
options.headers = headers;

export async function postTransaction(data) {
    
    try {
        const response = await serviceContext.post(`${ReportsURL}transaction/user`, JSON.stringify(data), options); //+"transactions", JSON.stringify(data), options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function postTransaction2(data) {
    
    try {
        const response = await serviceContext.post(`${ReportsURL}transaction2/user`, JSON.stringify(data), options); //+"transactions", JSON.stringify(data), options);
        if(response.hasError === true){
            return false;
        }
        else{
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

// export async function postTransactionCsv(data) {
    
//     try {
//         const response = await serviceContext.post(ReportsURL+"transactions/csv", JSON.stringify(data), options);
//         if(response.hasError === true){
//             return false;
//         }
//         else{
//             const res = response.json();
//             return res;
//         }
//     }
//     catch (error) {
//         return error;
//     }
// };

// export async function postTransactionPdf(data) {
    
//     try {
//         const response = await serviceContext.post(ReportsURL+"transactions/pdf", JSON.stringify(data), options);
//         if(response.hasError === true){
//             return false;
//         }
//         else{
//             const res = response.json();
//             return res;
//         }
//     }
//     catch (error) {
//         return error;
//     }
// };
